import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { PermissionService } from 'src/app/auth/services/permission.service';
import { AccessLevel } from 'src/app/auth/types/access-level';

@Directive({
  selector: '[requireAccess]',
  standalone: false,
})
export class RequireAccessDirective implements OnDestroy {
  rendered = false;
  private level?: AccessLevel;
  private entityId?: string;
  private allowSharedAccess = false;
  private shareAccessSubscription?: Subscription;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainerRef: ViewContainerRef,
    private permissionService: PermissionService,
  ) {
    this.shareAccessSubscription =
      this.permissionService.shareAccessChanged$?.subscribe(() =>
        this.updateView(),
      );
  }

  ngOnDestroy(): void {
    this.shareAccessSubscription?.unsubscribe();
  }

  @Input() set requireAccess(level: AccessLevel | undefined) {
    this.level = level;
    this.updateView();
  }

  @Input() set requireAccessEntityId(entityId: string | undefined) {
    this.entityId = entityId;
    this.updateView();
  }

  @Input() set requireAccessAllowSharedAccess(allowSharedAccess: boolean) {
    this.allowSharedAccess = !!allowSharedAccess;
    this.updateView();
  }

  private updateView(): void {
    const hasAccess =
      !!this.level &&
      this.permissionService.meetsAccessRequirement({
        requireAccess: this.level,
        entityId: this.entityId,
        allowSharedAccess: this.allowSharedAccess,
      });

    if (hasAccess && !this.rendered) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.rendered = true;
    } else if (!hasAccess && this.rendered) {
      this.viewContainerRef.clear();
      this.rendered = false;
    }
  }
}
